/**
 * @desc 编辑接口同步信息
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.DataDimensionApiSyncRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dimension/api/sync`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
